import React from 'react';
import TextAdapter from './TextAdapter';
import { AdapterProps } from '../types';

const PasswordAdapter = (props: AdapterProps['password']) => (
  <TextAdapter type="password" {...props} />
);

export default PasswordAdapter;
